import {CustomerFieldClassification} from '../../../gql/customer/graphql.ts';

interface CustomerField {
    key?: string | null;
    name?: string | null;
    default?: boolean | null;
    classification?: string | null;
    show_public?: boolean | null;
    edit_public?: boolean | null;
}

interface OwnProps {
    disabled: boolean;
    customerField: CustomerField;
    defaultValue: string | null | undefined;
}

export function CustomerField({customerField, defaultValue, disabled}: OwnProps) {
    if (!customerField.key) {
        return null;
    }

    return (
        <label key={'custom-field-' + customerField.key}>
            {customerField.name}
            <input
                type={typeFromClassification(customerField.classification as CustomerFieldClassification)}
                name={customerField.key + (!customerField.edit_public ? '-disabled' : '')}
                defaultValue={defaultValue || undefined}
                disabled={disabled}
            />
        </label>
    );
}

function typeFromClassification(classification: CustomerFieldClassification | null | undefined): string {
    switch (classification) {
        case CustomerFieldClassification.Date:
            return 'date';
        case CustomerFieldClassification.Number:
            return 'number';
        default:
            return 'text';
    }
}
